/* eslint-disable */
const cookieConsent = {
    cookieName: 'af-mtm-cookie-consent',
    yes: 'y',
    no: 'n',

    initCookieBanner: function () {
        $(window).on('load', function () {
            var cookieBanner = $('#cookie-banner-modal');

            var showBannerOnPage = $('#disable-cookie-consent').length === 0;

            if (cookie === null) {
                cookieConsent.deleteTrackingCookies();

                if (showBannerOnPage) {
                    cookieBanner.modal('show');

                    cookieBanner.on('click', '.cookie-knapp-ja', function () {
                        cookieConsent.setConsentCookie(cookieConsent.yes);
                        cookieBanner.modal('hide');
                        consentSet(true)
                    });
                    cookieBanner.on('click', '.cookie-knapp-nej', function () {
                        cookieConsent.setConsentCookie(cookieConsent.no);
                        cookieConsent.deleteTrackingCookies();
                        cookieBanner.modal('hide');
                        consentSet()
                    });
                }
            }
        });
    },

    setConsentCookie: function (consent) {
        setCookie(cookieConsent.cookieName, consent, 2 * 365, '/');
        cookie = getCookie(cookieConsent.cookieName);
    },

    deleteTrackingCookies: function () {
        var propertyID = 'UA-18846229-15';
        var containerID = 'GTM-KN3V3S';
        var cookies = [
            '_ga',
            '_gat',
            '_gid',
            '_ga_' + containerID,
            '_gac_' + propertyID,
            '_gac_gb_' + containerID,
            '_gat_' + propertyID,
            'AMP_TOKEN', // GA Client ID
            'FPID', // GA server side cookie
            'FPLC', // GA server side cookie
            'nmstat', // Siteimprove
            '__cfduid', // Cloudflare
            '_pk_ref',
            '_pk_cvar',
            '_pk_id',
            '_pk_ses'
        ];
        deleteCookies(cookies);
    },

    deleteTrackingCookiesIfDeclined: function () {
        if (cookie === cookieConsent.no) {
            cookieConsent.deleteTrackingCookies();
        }
    },
};

let cookie = getCookie(cookieConsent.cookieName);

(function () {
    deleteCookies(['af-cookie-consent'])
    cookieConsent.initCookieBanner();
    cookieConsent.deleteTrackingCookiesIfDeclined();
})();
